import { useState } from "react";
import {
  Tooltip,
  Modal,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export default function DescriptionCell({ description = "" }) {
  const [open, setOpen] = useState(false);

  const words = description.trim().split(" ");

  // First 5 words truncate
  const shortText = words.length > 5 ? words.slice(0, 5).join(" ") : description;

  // ✅ Show eye if text length > 10 characters
  const shouldShowEye = description.length > 20;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          maxWidth: "240px",
        }}
      >
        <Typography
          sx={{
            maxWidth: "200px",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            cursor: "default",
          }}
          title={description}
        >
          {shortText}
        </Typography>

        {/* Eye Icon only if more than 10 characters */}
        {shouldShowEye && (
          <Tooltip title="View details">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(true);
              }}
            >
              <VisibilityOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            p: 3,
            bgcolor: "background.paper",
            width: 450,
            mx: "auto",
            mt: "10%",
            borderRadius: 2,
            maxHeight: "70vh",
            overflowY: "auto",
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" mb={2}>
            Description Details
          </Typography>

          <Typography sx={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {description}
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
